package com.ijoin.platform

/**
 * Information about the web browser and device.
 * Used to show appropriate app store links.
 */
enum class MobileOS {
    IOS,
    ANDROID,
    NONE  // Desktop or unknown
}

/**
 * Gets information about the current web browser.
 * Returns MobileOS.NONE for non-web platforms.
 */
expect fun getWebMobileOS(): MobileOS

/**
 * Checks if the current web browser is on a mobile device.
 */
expect fun isWebMobile(): Boolean
